import { datadogRum } from '@datadog/browser-rum';
import { AnalyticsBrowser } from '@segment/analytics-next';

const { currentUser, segmentToken, segmentCategory } = window;

const isProd = process.env.NODE_ENV === 'production';
let analytics: AnalyticsBrowser;
if (isProd) {
    analytics = new AnalyticsBrowser();
    analytics.load({ writeKey: segmentToken });
    analytics.debug(false);
}

// Context data is automatically generated except for the "source".
const state = {
    user: currentUser,
    loggedId: false,
};

/**
 * By default, traits are cached in the browser’s local storage and attached to each subsequent identify call.
 * @return {object} - common user data for tracking
 */
function _getUserTraits() {
    return {
        'Account ID': state.user.accountUuid,
        source: segmentCategory,
    };
}

function _getCategory() {
    return { context: { source: segmentCategory } };
}

/* //I dont think this is needed anymore but keeping around for the moment incase it is in the near future.
 *
 * Note: Segment recommends against using identify for anonymous visitors to your site. analytics.js automatically retrieves
 * an anonymousId from localStorage or assigns one for new visitors. It will be attached to all page and track events
 * both before and after an identify.
 */
/*function logIdentity() {
    if (isProd) {
        if (state.user) {
            analytics.identify(
                state.user.accountUuid,
                _getUserTraits(),
                _getCategory()
            );
            state.loggedId = true;
        }
    }
}

function updateUserTraits(user) {
    state.user = Object.assign({}, state.user, user);
    logIdentity();
}*/

function _setDefaultProps(eventProps: Record<string, unknown>) {
    eventProps.source = segmentCategory;
    eventProps.traits = state.user ? _getUserTraits() : {};
}

/**
 **** ATTENTION **** PLEASE CONFORM TO THESE STANDARDS ****
 1. Prepend the functional area to the event name.
 2. Use plain english.
 'Agreed to Disclaimer' vs 'DISCLAIMER_AGREED'
 'Agreed to Disclaimer' vs 'Disclaimer Agreed'
 3. Use "Title Case".
 'Added Certificate' vs 'add certificate'
 'Agreed to Disclaimer' vs 'disclaimer agreed'
 4. Describe the action with as few words as possible.
 'Added Certificate' vs 'added new cert'
 5. Keep the name short and concise (three to four words).

 @param {string} eventName
 @param {Record<string, unknown>} eventProps
 */
function logEvent(eventName: string, eventProps: Record<string, unknown> = {}) {
    if (isProd && state.user?.accountUuid) {
        _setDefaultProps(eventProps);
        analytics
            .track(eventName, eventProps, _getCategory())
            .catch(e => console.warn(`Error with segment analytics: ${e}`));
        eventProps.action = 'event';
        datadogRum.addAction(eventName, eventProps);
    }
}

/*
    **** ATTENTION **** PLEASE CONFORM TO THESE STANDARDS ****
    pageName = 'Simple Name' in title case.
    props = add any properties you would like.  url, path and page title will be auto appended.
*/
function logPageView(pageName: string, props: Record<string, unknown> = {}) {
    if (isProd && state.user?.accountUuid) {
        const page = window.location;
        const properties = Object.assign({}, props);
        properties.url = page.href;
        properties.path = page.pathname;
        properties.title = document.title;
        properties.traits = state.user ? _getUserTraits() : {};
        properties.email = '';
        analytics
            .page(segmentCategory, pageName, properties, _getCategory())
            .catch(e => console.warn(`Error with segment analytics: ${e}`));
        props.action = 'view';
        datadogRum.addAction(pageName, props);
    }
}

export default {
    logEvent,
    logPageView,
};
